module.exports = __webpack_public_path__ + "static/img/MECTRONFEELER.0749f6b7.png";